let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1jdJx")).then(() => parcelRequire('8GUOz'));